class CrowdriffGallery {
  constructor(crowdriffGallery) {
    this.options = crowdriffGallery.querySelector('.js-crowdriff-options');
    this.embedContainer = crowdriffGallery.querySelector('.js-crowdriff-embed-container');
    this.galleryContainer = crowdriffGallery.querySelector('.js-crowdriff-gallery-container');

    for(let option of this.options.children) {
      if(this.embedContainer) {
        //use legacy embeds
        option.addEventListener('click', (event) => this.changeEmbed(event));
      } else if(this.galleryContainer) {
        //use new custom CR
        option.addEventListener('click', (event) => this.changeGallery(event));
      }
      
      option.addEventListener('click', (event) => this.changeOption(event));
    }
  }

  /*
    All embeds are already loaded in, we just need to conditionally show/hide them
  */
  changeEmbed(event) {
    const galleryButton = event.target;
    const requestedGalleryID = galleryButton.dataset.crowdriffId

    // hide all embeds
    const embedElements = this.embedContainer.children
    const embedElementsArray = [...embedElements]

    embedElementsArray.forEach((embedElement) => {
      embedElement.style.display = 'none'
    })

    // show the one embed requested
    const requestedGalleryElement = this.embedContainer.querySelector(`#cr__${requestedGalleryID}`)

    if (requestedGalleryElement != null) {
      requestedGalleryElement.style.display = 'block'
    }
  }

  changeGallery(event) {
    event.preventDefault();
    const galleryButton = event.target;
    const requestedGalleryID = galleryButton.dataset.galleryId

    // hide all embeds
    const galleryElements = this.galleryContainer.children
    const galleryElementsArray = [...galleryElements]

    galleryElementsArray.forEach((galleryElement) => {
      galleryElement.classList.remove('--active');
    })

    // show the one embed requested
    const requestedGalleryElement = this.galleryContainer.querySelector(`[data-gallery-id="${requestedGalleryID}"]`)

    if (requestedGalleryElement != null) {
      requestedGalleryElement.classList.add('--active');
    }
  }

  changeOption(event) {
    event.preventDefault();
    const galleryButton = event.target;

    //set active class for option button
    for(let option of this.options.children) {
      if(option == galleryButton) {
        option.classList.add('--active');
      } else {
        option.classList.remove('--active');
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const crowdriffGalleries = document.querySelectorAll('.js-crowdriff-options');
  if (crowdriffGalleries.length > 0) {
    const crowdriffGalleriesArray = [...crowdriffGalleries];
  
    crowdriffGalleriesArray.forEach((crowdriffGallery) => {
      new CrowdriffGallery(crowdriffGallery.parentElement)
    });
  }
});
